export const SLPcameraLang = {
    uploaded: 'فایل بارگذاری شد',
    err400: 'تایپ فایل وارد شده اشتباه است. لطفا یک فایل با فرمت jpg، jpeg، png یا gif آپلود کنید.',
    capture: 'گرفتن عکس',
    err: 'خطایی در آپلود عکس رخ داده است,لطفا دوباره تلاش نمایید',
};
